import { useMe } from "@/hooks/use-auth";

import type { NavAccess } from "./nav-config";

/** Permission/role gate shared by the desktop sidebar and the mobile menu. */
export function useNavAccess() {
  const { data: me } = useMe();

  function check(rule: Pick<NavAccess, "permission" | "roles">): boolean {
    const permissionOk =
      !rule.permission || (me?.permissions?.includes(rule.permission) ?? false);
    const roleOk =
      !rule.roles ||
      (me?.roleNames?.some((r) => rule.roles?.includes(r)) ?? false);
    return permissionOk && roleOk;
  }

  function isAllowed(item: NavAccess): boolean {
    return item.anyOf ? item.anyOf.some(check) : check(item);
  }

  return { isAllowed };
}
